module.exports = __webpack_public_path__ + "img/右2logo.dcca7629.png";